import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Media carousel',
    defaultMessage: 'Media carousel',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  slides: {
    id: 'Slides',
    defaultMessage: 'Slides',
  },
  slide: {
    id: 'Slide',
    defaultMessage: 'Slide',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  altText: {
    id: 'Alt text',
    defaultMessage: 'Alt text',
  },
  caption: {
    id: 'Caption',
    defaultMessage: 'Caption',
  },
  autoplay: {
    id: 'Autoplay',
    defaultMessage: 'Autoplay',
  },
  showDots: {
    id: 'Show dots',
    defaultMessage: 'Show dots',
  },
});

export const SlideItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.slide),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['image', 'alt', 'caption'],
    },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'image',
    },
    alt: {
      title: intl.formatMessage(messages.altText),
      type: 'string',
    },
    caption: {
      title: intl.formatMessage(messages.caption),
      type: 'string',
    },
  },
  required: [],
});

/**
 * Schema do bloco Media Carousel.
 * Carrossel de imagens/infográficos com navegação por dots (e setas).
 * Ver docs/specs/schema-decisions.md §9.
 */
const MediaCarouselSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['slides', 'autoplay', 'showDots'],
    },
  ],
  properties: {
    slides: {
      title: intl.formatMessage(messages.slides),
      widget: 'object_list',
      schema: SlideItemSchema({ intl }),
    },
    autoplay: {
      title: intl.formatMessage(messages.autoplay),
      type: 'boolean',
      default: false,
    },
    showDots: {
      title: intl.formatMessage(messages.showDots),
      type: 'boolean',
      default: true,
    },
  },
  required: [],
});

export default MediaCarouselSchema;
